module.exports = __webpack_public_path__ + "img/夏枯草.3da60b29.jpg";